export const getUseBifrostGateway = () => window.USE_BIFROST_GATEWAY;
